export const FOLD_LAYOUT_LEFT_REQUEST = 'FOLD_LAYOUT_LEFT_REQUEST';